<template>
  <card class="custom-shadow-card-header custom-table-responsive">
    <div class="row">
      <div class="col-6 text-center">
        <label class="mb-3">{{ $t('common_words.image') }}</label>
        <el-upload
          :show-file-list="false"
          :auto-upload="false"
          :on-change="changeGeneralPhoto"
          ref="general-photo-uploader"
          class="avatar-uploader"
          :action="getAxiosURL()"
        >
          <img v-if="generalImageUrl" :src="generalImageUrl" class="general" />
          <em v-else class="el-icon-plus general-uploader-icon"></em>
          <div
            v-if="generalImageError"
            slot="tip"
            class="el-upload__tip text-danger"
          >
            {{ $t('common_words.jpg_notice') }}
          </div>
        </el-upload>
      </div>
      <div class="col-6 text-center">
        <label class="mb-3">{{ $t('common_words.observations') }}</label>
        <textarea v-model="generalObservation" class="form-control" rows="6">
        </textarea>
      </div>
    </div>
    <div class="row mt-5">
      <div class="table-responsive">
        <table class="table table-striped table-bordered not-last-td">
          <thead>
            <tr class="cusmtom-thead-color">
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.task') }}
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.type_of_task') }}
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.value') }}
              </th>
              <th
                v-if="photoColumn"
                scope="col"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('common_words.image') }}
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.observations') }}
                {{ $t('table.of') }}
                {{ $t('common_words.tasks') }}
              </th>
              <th
                v-if="observationBySubcategory"
                scope="col"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('common_words.observations') }}
                {{ $t('table.of') }}
                {{ $t('audit.subcategories') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(task, index) in tasksForm" :key="index">
              <td class="text-center" style="min-width: 200px">
                <el-input
                  v-model="task.name"
                  disabled
                  type="text"
                  class="shadow-sm text-center required-areas"
                />
              </td>
              <td class="text-center" style="min-width: 200px">
                <el-input
                  :value="getCalificationDescription(task)"
                  disabled
                  type="textarea"
                  class="shadow-sm text-center required-areas"
                />
              </td>
              <td class="text-center" style="min-width: 200px">
                <component
                  :is="getValueType(task)"
                  v-model="task.value"
                  v-bind="getProps(task)"
                  ref="dinamicInput"
                ></component>
              </td>
              <td
                v-if="photoColumn"
                class="text-center"
                style="min-width: 200px"
              >
                <el-upload
                  v-if="task.photo_required === 1"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="(file) => changePhoto(file, index)"
                  class="avatar-uploader"
                  :ref="`photo-uploader-${index}`"
                  :action="getAxiosURL()"
                >
                  <img
                    v-if="task.imageUrl"
                    :src="task.imageUrl"
                    class="avatar"
                  />
                  <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                  <div
                    v-if="task.imageError && task.imageError"
                    slot="tip"
                    class="el-upload__tip text-danger"
                  >
                    {{ $t('common_words.jpg_notice') }}
                  </div>
                  <div
                    v-if="task.showImageError"
                    slot="tip"
                    class="el-upload__tip text-danger"
                  >
                    {{ $t('common_words.observations') }}
                  </div>
                </el-upload>
              </td>
              <td class="text-center" style="min-width: 200px">
                <el-input
                  type="textarea"
                  :placeholder="$t('common_words.observations')"
                  v-model="task.observation"
                />
              </td>
              <td
                v-if="observationBySubcategory"
                class="text-center"
                style="min-width: 200px"
                :rowspan="getRowSpan(task.audit2_subcategory_id, index)"
                v-show="getRowSpan(task.audit2_subcategory_id, index) > 0"
              >
                <textarea
                  class="form-control"
                  :style="`height: ${
                    getRowSpan(task.audit2_subcategory_id, index) * 66
                  }px`"
                  v-model="subcategoryObservations[task.audit2_subcategory_id]"
                  :placeholder="$t('common_words.observations')"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 mt-5">
        <div class="row">
          <div class="col-6 text-right">
            <button
              class="btn btn-fill btn-info btn-wd shadow-sm"
              @click="validateForm"
            >
              {{ $t('common_words.save_data') }}
            </button>
          </div>
          <div class="col-6">
            <button
              class="btn btn-fill btn-danger btn-wd shadow-sm"
              @click="deleteAll"
            >
              {{ $t('common_words.delete') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import { AXIOS_URL } from 'src/util/Util';
import DateCapture from 'src/components/Forms/DateCapture.vue';
import i18n from 'src/i18n';
import NumericCapture from 'src/components/Forms/NumericCapture.vue';
import SelectableCapture from 'src/components/Forms/SelectableCapture.vue';
import TextCapture from 'src/components/Forms/TextCapture.vue';
import TimeCapture from 'src/components/Forms/TimeCapture.vue';
import FormulaCapture from 'src/components/Forms/FormulaCapture.vue';

export default {
  name: 'CaptureConfirm',
  components: {
    DateCapture,
    FormulaCapture,
    NumericCapture,
    SelectableCapture,
    TextCapture,
    TimeCapture,
  },
  props: {
    module: {
      type: String,
    },
    tasks: {
      type: Array,
      required: true,
    },
    subObservations: {
      type: Array,
      default: [],
    },
    farmId: {
      type: Number,
      required: true,
    },
    photoColumn: {
      type: Boolean,
      default: false,
    },
    observationBySubcategory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      generalImage: null,
      generalImageUrl: null,
      generalImageError: null,
      generalObservation: null,
      tasksForm: [],
      showImageError: false,
      subcategoryObservations: {},
    };
  },
  methods: {
    getAxiosURL() {
      return AXIOS_URL;
    },
    getValueType(task) {
      const types = {
        Texto: 'TextCapture',
        Numérica: 'NumericCapture',
        Objetiva: 'SelectableCapture',
        Subjetiva: 'SelectableCapture',
        'Subjetiva 2': 'SelectableCapture',
        Única: 'SelectableCapture',
        Múltiple: 'SelectableCapture',
        'Fuente de Datos': 'SelectableCapture',
        'Fuente de Datos Múltiple': 'SelectableCapture',
        Fecha: 'DateCapture',
        Hora: 'TimeCapture',
        Fórmula: 'FormulaCapture',
      };
      return types[task.calification_type];
    },
    getProps(task) {
      let props = {};
      switch (task.calification_type) {
        case 'Numérica':
          props.min = Number(task.minimum);
          props.max = Number(task.maximum);
          if (task.value) {
            task.value = Number(task.value);
          }
          break;
        case 'Objetiva':
          props.items = ['NA', 'SI', 'NO'];
          if (task.is_required === 1) {
            props.items.shift();
          }
          break;
        case 'Subjetiva':
          props.items = [...Array(11).keys()];
          if (task.is_required !== 1) {
            props.items.unshift('NA');
          }
          break;
        case 'Subjetiva 2':
          props.items = [...Array(6).keys()];
          if (task.is_required !== 1) {
            props.items.unshift('NA');
          }
          break;
        case 'Única':
          switch (this.module) {
            case 'audit':
              props.items = [...task.audit_option_tasks];
              break;
            case 'quality':
              props.items = [...task.quality_option_tasks];
              break;
            case 'certification':
              props.items = [...task.certification_option_tasks];
              break;
            default:
              break;
          }
          props.objects = true;
          break;
        case 'Múltiple':
          switch (this.module) {
            case 'audit':
              props.items = [...task.audit_option_tasks];
              break;
            case 'quality':
              props.items = [...task.quality_option_tasks];
              break;
            case 'certification':
              props.items = [...task.certification_option_tasks];
              break;
            default:
              break;
          }
          props.multiple = true;
          props.objects = true;
          break;
        case 'Fuente de Datos':
          props.items = task.dataSource;
          props.objects = true;
          break;
        case 'Fuente de Datos Múltiple':
          props.items = task.dataSource;
          props.multiple = true;
          props.objects = true;
          break;
        case 'Texto':
          props.min = Number(task.minimum);
          props.max = Number(task.maximum);
          break;
        case 'Fórmula':
          props.formulaExpression = task.formula_expression || '';
          break;
      }
      return { ...props, id: task.id, required: task.is_required };
    },
    getCalificationDescription(task) {
      const descriptions = {
        Numérica: `${i18n.t('ad_audit.numeric_description')} ${
          task.minimum
        } ${i18n.t('common_words.and')} ${task.maximum}`,
        Objetiva: `${i18n.t('ad_audit.objective_description')}`,
        Subjetiva: `${i18n.t('ad_audit.subjective_description')}`,
        'Subjetiva 2': `${i18n.t('ad_audit.subjective_description')}`,
        Única: `${i18n.t('ad_audit.unique_description')}`,
        Múltiple: `${i18n.t('ad_audit.multiple_description')}`,
        'Fuente de Datos': `${i18n.t('ad_audit.data_source_description')}`,
        Fecha: `${i18n.t('ad_audit.date_description')}`,
        Hora: `${i18n.t('ad_audit.hour_description')}`,
        'Fuente de Datos Múltiple': `${i18n.t(
          'ad_audit.multiple_data_source_description'
        )}`,
        Texto: `${i18n.t('ad_audit.text_description')} ${task.minimum} ${i18n.t(
          'common_words.and'
        )} ${task.maximum} ${i18n.t('common_words.characters')}.`,
        Fórmula: task.formula_expression
          ? `Fórmula: ${this.formatFormulaExpression(task.formula_expression)}`
          : 'Fórmula automática',
      };
      return descriptions[task.calification_type];
    },
    formatFormulaExpression(formula) {
      if (!formula) return '';
      let formatted = formula;
      const tasksWithRefs = this.tasksForm.filter((t) => t.reference_name);

      tasksWithRefs.sort(
        (a, b) => b.reference_name.length - a.reference_name.length
      );

      tasksWithRefs.forEach((t) => {
        const escaped = t.reference_name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`\\b${escaped}\\b`, 'gi');
        formatted = formatted.replace(regex, `[${t.name}]`);
      });
      return formatted;
    },
    validateForm() {
      const validatedForm = !this.$refs.dinamicInput.some(
        (input) => input.validate() === false
      );
      let requiredPhotoIndex = null;
      const validatedFormPhotos = !this.$refs.dinamicInput.some((_, index) => {
        if (
          this.tasksForm[index].photo_required === 1 &&
          !this.tasksForm[index].photo &&
          this.tasksForm[index].is_required == 1
        ) {
          requiredPhotoIndex = index;

          return true;
        }
      });
      if (!validatedFormPhotos) {
        this.validateRequiredPhoto(requiredPhotoIndex);
      }
      if (validatedForm && validatedFormPhotos) {
        const data = {
          tasksForm: this.tasksForm,
          image: this.generalImage,
          observations: this.generalObservation,
          subcategoryObservations: this.subcategoryObservations,
        };
        this.$emit('save', data);
      }
    },
    validateRequiredPhoto(indexPhoto) {
      this.$refs[`photo-uploader-${indexPhoto}`][0].$el.classList.add(
        'avatar-uploader-bad'
      );
      this.$set(this.tasksForm, indexPhoto, {
        ...this.tasksForm[indexPhoto],
        showImageError: true,
      });
      setTimeout(() => {
        this.$refs[`photo-uploader-${indexPhoto}`][0].$el.classList.remove(
          'avatar-uploader-bad'
        );
        this.tasksForm[indexPhoto].showImageError = false;
      }, 5000);
    },
    validatePhoto(fileType, index) {
      const isJPG = ['image/jpeg', 'image/png'].includes(fileType);
      if (!isJPG) {
        if (this.$refs[`photo-uploader-${index}`][0]) {
          this.$refs[`photo-uploader-${index}`][0].$el.classList.add(
            'avatar-uploader-bad'
          );
          this.$set(this.tasksForm, index, {
            ...this.tasksForm[index],
            imageError: true,
          });
          setTimeout(() => {
            this.$refs[`photo-uploader-${index}`][0].$el.classList.remove(
              'avatar-uploader-bad'
            );
            this.tasksForm[index].imageError = false;
          }, 5000);
        }
        return false;
      }
      return true;
    },
    changePhoto(file, index) {
      const validatedPhoto = this.validatePhoto(file.raw.type, index);
      if (!validatedPhoto) {
        this.$refs[`photo-uploader-${index}`][0].clearFiles();
      } else {
        this.$set(this.tasksForm, index, {
          ...this.tasksForm[index],
          photo: file.raw,
          imageUrl: URL.createObjectURL(file.raw),
        });
      }
    },
    changeGeneralPhoto(file) {
      const isJPG = ['image/jpeg', 'image/png'].includes(file.raw.type);
      if (!isJPG) {
        this.$refs['general-photo-uploader'].clearFiles();
        this.$refs['general-photo-uploader'].$el.classList.add(
          'avatar-uploader-bad'
        );
        this.generalImageError = true;
        setTimeout(() => {
          this.$refs['general-photo-uploader'].$el.classList.remove(
            'avatar-uploader-bad'
          );
          this.generalImageError = false;
        }, 5000);
      } else {
        this.generalImage = file.raw;
        this.generalImageUrl = URL.createObjectURL(file.raw);
      }
    },
    deleteAll() {
      this.$emit('delete');
    },
    getRowSpan(subcategoryId, index) {
      const groupedTasks = this.tasksForm.filter(
        (t) => t.audit2_subcategory_id === subcategoryId
      );
      const firstIndex = this.tasksForm.findIndex(
        (t) => t.audit2_subcategory_id === subcategoryId
      );

      if (firstIndex === index) {
        return groupedTasks.length;
      } else {
        return 0;
      }
    },






    /**
     * Evaluates a single formula expression given the current tasksForm state.
     * Mirrors the PHP evaluateFormulaPHP logic.
     * @param {string} formulaExpression - The formula string to evaluate.
     * @param {Array<Object>} allTasks - List of task objects to use as variables.
     * @returns {string|number} The evaluated result.
     */


    evaluateFormulaJS(formulaExpression, allTasks) {
      if (!formulaExpression) return '0';



      const refMap = {};
      const orderedRefNames = [];
      allTasks.forEach((t) => {
        const refName = (t.reference_name || '').toLowerCase().trim();
        if (!refName) return;
        orderedRefNames.push(refName);
        const val = t.value;
        if (val === 'NA' || val === 'N/A') {
          refMap[refName] = '"NA"';
        } else if (val === '' || val === null || val === undefined) {
          refMap[refName] = 'null';
        } else if (t.calification_type === 'Objetiva') {
          refMap[refName] = String(val).toUpperCase() === 'SI' ? 1 : 0;
        } else {
          const num = parseFloat(val);
          refMap[refName] = isNaN(num) ? 0 : num;
        }
      });

      let expr = formulaExpression;


      expr = expr.replace(
        /\b([a-zA-Z0-9_]+):([a-zA-Z0-9_]+)\b/gi,
        (_, r1, r2) => {
          const k1 = r1.toLowerCase();
          const k2 = r2.toLowerCase();
          const i1 = orderedRefNames.indexOf(k1);
          const i2 = orderedRefNames.indexOf(k2);
          if (i1 !== -1 && i2 !== -1) {
            const mn = Math.min(i1, i2);
            const mx = Math.max(i1, i2);
            return orderedRefNames.slice(mn, mx + 1).join(',');
          }
          return `${r1}:${r2}`;
        }
      );

      if (/\bREF_[A-Za-z0-9_]+\b/i.test(expr)) {
        /**
         * Checks if a value is a valid number.
         * @param {*} v - The value to check.
         * @returns {boolean} True if numeric, false otherwise.
         */
        const isNumericValue = (v) =>
          v !== '' &&
          v !== null &&
          v !== undefined &&
          !isNaN(Number(v)) &&
          !isNaN(parseFloat(v));
        const objetivaAnswers = ['SI', 'YES', 'SIM', 'NO', 'NÃO', 'NAO'];

        const hasAnsweredReference = allTasks.some((t) => {
          const refName = (t.reference_name || '').toLowerCase().trim();
          if (!refName) return false;
          const val = t.value;
          if (
            !isNumericValue(val) &&
            !objetivaAnswers.includes(String(val).trim().toUpperCase())
          ) {
            return false;
          }
          const escaped = refName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          return new RegExp(`\\b${escaped}\\b`, 'i').test(expr);
        });

        if (!hasAnsweredReference) return '';
      }

      expr = expr.replace(/([0-9.]+)%/g, '($1/100)');

      const sortedRefs = Object.keys(refMap).sort(
        (a, b) => b.length - a.length
      );
      sortedRefs.forEach((rName) => {
        const val = refMap[rName];
        const escaped = rName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        expr = expr.replace(new RegExp(`\\b${escaped}\\b`, 'gi'), `(${val})`);
      });

      expr = expr.replace(/\bREF_[A-Za-z0-9_]+\b/gi, '(null)');

      expr = expr.split('^').join('**');

      expr = expr.replace(/<>/g, '!=');
      expr = expr.replace(/(?<![<>!=])=(?!=)/g, '===');

      const sum = (...args) => {
        let s = 0;
        for (let a of args) {
          if (typeof a === 'number' && !isNaN(a)) s += a;
        }
        return s;
      };
      const average = (...args) => {
        let s = 0,
          c = 0;
        for (let a of args) {
          if (typeof a === 'number' && !isNaN(a)) {
            s += a;
            c++;
          }
        }
        return c > 0 ? s / c : 0;
      };
      const max = (...args) => {
        const nums = args.filter((a) => typeof a === 'number' && !isNaN(a));
        return nums.length ? Math.max(...nums) : 0;
      };
      const min = (...args) => {
        const nums = args.filter((a) => typeof a === 'number' && !isNaN(a));
        return nums.length ? Math.min(...nums) : 0;
      };
      const count = (...args) => {
        let c = 0;
        for (let a of args) {
          if (
            a === 'NA' ||
            a === 'N/A' ||
            (typeof a === 'number' && !isNaN(a) && a > 0)
          ) {
            c++;
          }
        }
        return c;
      };
      const countif = (...args) => {
        if (args.length < 2) return 0;
        const cond = String(args[args.length - 1])
          .trim()
          .replace(/^["']|["']$/g, '');
        const vals = args.slice(0, -1);
        return vals.filter((a) => {
          if (cond.startsWith('>')) return a > parseFloat(cond.slice(1));
          if (cond.startsWith('<')) return a < parseFloat(cond.slice(1));
          return String(a) === cond;
        }).length;
      };
      const ifFn = (cond, t = 0, f = 0) => (cond ? t : f);
      const isblank = (v) =>
        v === null || v === undefined || v === '' || v === 'NA' || v === 'N/A';

      expr = expr.replace(/\b(ISBLANK|ESBLANCO)\s*\(/gi, 'isblank(');
      expr = expr.replace(/\b(SUM|SUMA)\s*\(/gi, 'sum(');
      expr = expr.replace(/\b(AVERAGE|PROMEDIO)\s*\(/gi, 'average(');
      expr = expr.replace(/\b(MAX|MAXIMO)\s*\(/gi, 'max(');
      expr = expr.replace(/\b(MIN|MINIMO)\s*\(/gi, 'min(');
      expr = expr.replace(/\b(COUNT|CONTAR)\s*\(/gi, 'count(');
      expr = expr.replace(/\b(COUNTA|CONTARA)\s*\(/gi, 'count(');
      expr = expr.replace(/\b(COUNTIF|CONTAR\.SI)\s*\(/gi, 'countif(');
      expr = expr.replace(/\b(IF|SI)\s*\(/gi, 'ifFn(');

      try {
        // eslint-disable-next-line no-new-func
        const fn = new Function(
          'sum',
          'average',
          'max',
          'min',
          'count',
          'countif',
          'ifFn',
          'isblank',
          `"use strict"; return (${expr});`
        );
        const result = fn(sum, average, max, min, count, countif, ifFn, isblank);
        if (typeof result === 'number' && !isNaN(result)) {
          return String(result);
        }
        return '0';
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(
          '[evaluateFormulaJS] failed to evaluate formula, defaulting to 0',
          { formulaExpression, error: e }
        );
        return '0';
      }
    },

    /**
     * Recalculates all Fórmula-type tasks based on current tasksForm values.
     * Called on created() and whenever a non-formula task value changes.
     */
    _recalcFormulas() {
      if (this._isRecalculating) return;
      this._isRecalculating = true;
      try {
        this.tasksForm.forEach((task, idx) => {
          if (task.calification_type === 'Fórmula' && task.formula_expression) {
            const computed = this.evaluateFormulaJS(
              task.formula_expression,
              this.tasksForm
            );
            if (String(task.value) !== computed) {
              this.$set(this.tasksForm, idx, { ...task, value: computed });
            }
          }
        });
      } finally {
        this._isRecalculating = false;
      }
    },
  },

  watch: {
    tasksForm: {
      deep: true,
      handler() {
        clearTimeout(this._recalcTimer);
        this._recalcTimer = setTimeout(() => this._recalcFormulas(), 250);
      },
    },
  },

  created() {
    this.tasksForm = [...this.tasks];
    this.tasksForm.forEach((task) => {
      const subId = task.audit2_subcategory_id;
      if (!(subId in this.subcategoryObservations)) {
        const value =
          this.subObservations[subId] !== undefined
            ? this.subObservations[subId]
            : '';
        this.$set(this.subcategoryObservations, subId, value);
      }
    });

    this.$nextTick(() => this._recalcFormulas());
  },

  beforeDestroy() {
    clearTimeout(this._recalcTimer);
  },
};
</script>
